var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLabel = function SvgLabel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.527 3.27c1.593-.233 2.196-.307 2.747-.156.1.027.197.06.292.097.532.208.97.628 2.109 1.766l1.199 1.2c1.06 1.059 1.811 1.812 2.319 2.458.498.634.705 1.096.747 1.558.015.173.015.346 0 .52l.665.059-.665-.06c-.042.462-.248.924-.747 1.558-.508.646-1.26 1.4-2.319 2.459-1.06 1.059-1.813 1.81-2.459 2.319-.633.498-1.095.705-1.557.746l.06.665-.06-.665a2.886 2.886 0 0 1-.52 0c-.462-.041-.924-.248-1.558-.747-.645-.507-1.399-1.26-2.458-2.319l-1.2-1.199c-1.137-1.138-1.557-1.576-1.766-2.108a2.9 2.9 0 0 1-.097-.292c-.15-.552-.076-1.154.156-2.747.165-1.132.282-1.931.438-2.547.152-.602.327-.969.574-1.254.092-.107.192-.207.3-.3.285-.246.651-.422 1.253-.574.617-.156 1.415-.273 2.547-.438Z",
    stroke: "#1E5DFF",
    strokeWidth: 1.669
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.301 10.156a1.679 1.679 0 1 0-2.374-2.374 1.679 1.679 0 0 0 2.374 2.374Z",
    stroke: "#1E5DFF",
    strokeWidth: 1.669
  })));
};
export default SvgLabel;